export const ACCOUNT = 'account';
export const LOADING = 'loading';
export const GENDER = 'gender';
export const DOCUMENT_TYPE = 'documentType';
export const INVOICE_TYPE = 'invoiceType';
export const ACCOUNT_INVOICE_TYPE = 'accountInvoiceType';
export const INPUT_MASK = 'inputMask';
export const YEAR = 'year'